import { BigFormRow, FormRow, FormSection, MediumFormRow } from 'framework/ui/layout';
import {
  Checkbox,
  CountryDropdown,
  DateInput,
  InputList,
  PhoneInput,
  TextArea,
  TextInput,
  EnumDropdown,
  LegalEntityEnum,
  ClearAfterUnmountWrapper,
} from 'framework/form';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { FinalizeVendorProfile } from '../types';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import { AccountInput } from 'domain/shared/ledger';
import { AGREEMENT_TYPES, AGREEMENT_TYPES_VALUES, VENDOR_DURACTION_TYPE_VALUES } from '../constants';
import VendorsContactInputs from '../shared/inputs/VendorContactsInput/VendorsContactInputs';

const FullVendorForm = () => {
  const { searchInvoiceAccount } = useLedgerService();

  return (
    <>
      <FormSection title="">
        <FormRow>
          <TextInput source="vendorName" label="" placeholder="Vendor name" />
          <CountryDropdown disabled label="" placeholder="Vendor country" source="country" />

          <TextInput disabled label="" placeholder="Tax registration number" source="taxRegistrationNumber" />
          <AccountInput
            disabled
            source="costCenterId"
            label=""
            placeholder="Cost center"
            cacheKey="vendor-accounts"
            loadDataMethod={searchInvoiceAccount}
          />
        </FormRow>

        <FormRow>
          <Checkbox disabled source="isDataProcessor" label="Is data processor?" />
          <Checkbox disabled source="isCompliant" label="Is vendor compliant?" />
          <Checkbox disabled source="isAutoApproved" label="Performance review and agreement extending is not needed" />
        </FormRow>

        <BigFormRow>
          <TextArea source="purpose" placeholder="Purpose" label="" />
        </BigFormRow>
      </FormSection>

      <MediumFormRow>
        <FormSection title="Vendor agreement">
          <MediumFormRow>
            <LegalEntityEnum
              disabled
              source="agreementDetails.legalEntity"
              label=""
              placeholder="Legal entity for Agreement"
            />
            <EnumDropdown
              options={AGREEMENT_TYPES_VALUES}
              source="agreementDetails.agreementType"
              label=""
              placeholder="Agreement type"
            />

            <EnumDropdown
              options={VENDOR_DURACTION_TYPE_VALUES}
              label=""
              source="agreementDetails.durationType"
              placeholder="Duration type"
            />
          </MediumFormRow>

          <MediumFormRow>
            <DateInput source="agreementDetails.startDate" label="" placeholder="Agreement start date" />
            <DateInput source="agreementDetails.endDate" label="" placeholder="Agreement end date" />
          </MediumFormRow>

          <BigFormRow>
            <ClearAfterUnmountWrapper
              isVisible={(vendor: FinalizeVendorProfile) =>
                vendor?.agreementDetails?.agreementType === AGREEMENT_TYPES.PUBLIC_OFFER
              }
            >
              <TextInput source="agreementDetails.publicOfferLink" label="" placeholder="Public offer link" />
            </ClearAfterUnmountWrapper>

            <ClearAfterUnmountWrapper
              isVisible={(vendor: FinalizeVendorProfile) =>
                vendor?.agreementDetails?.agreementType === AGREEMENT_TYPES.CONTRACT
              }
            >
              <NoteAttachmentUploaderInput
                isNewDocumentStorage
                source="agreementDetails.signedContractAttachment"
                label="Signed contract"
              />
            </ClearAfterUnmountWrapper>
          </BigFormRow>
        </FormSection>

        <FormSection title="Contacts">
          <BigFormRow>
            <MediumFormRow>
              <PhoneInput label="" placeholder="General vendor phone" source="phoneNumber" />
              <TextInput label="" placeholder="General vendor email" source="email" />
            </MediumFormRow>

            <InputList
              defaultValue={{
                name: '',
                phoneNumber: '',
                email: '',
              }}
              maxFields={3}
              inputTemplate={VendorsContactInputs}
              source="contacts"
            />
          </BigFormRow>
        </FormSection>
      </MediumFormRow>
    </>
  );
};

export default FullVendorForm;
